export default "__VITE_ASSET__D2_1Q5sm__"